/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipGate
 */
export interface TipGate {
    /**
     * Must tip the given user ID to unlock
     * @type {number}
     * @memberof TipGate
     */
    tipUserId: number;
}

/**
 * Check if a given object implements the TipGate interface.
 */
export function instanceOfTipGate(value: object): value is TipGate {
    let isInstance = true;
    isInstance = isInstance && "tipUserId" in value && value["tipUserId"] !== undefined;

    return isInstance;
}

export function TipGateFromJSON(json: any): TipGate {
    return TipGateFromJSONTyped(json, false);
}

export function TipGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tipUserId': json['tip_user_id'],
    };
}

export function TipGateToJSON(value?: TipGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tip_user_id': value.tipUserId,
    };
}

